import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getProducts = () => axios.get(`${API}/products`).then((r) => r.data);
export const getSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const createOrder = (data) => axios.post(`${API}/orders`, data).then((r) => r.data);

export const adminLogin = (password) =>
  axios.post(`${API}/admin/login`, { password }).then((r) => r.data);

const authHeader = (token) => ({ headers: { "X-Admin-Password": token } });

export const adminUpdateProduct = (id, data, token) =>
  axios.put(`${API}/admin/products/${id}`, data, authHeader(token)).then((r) => r.data);
export const adminCreateProduct = (data, token) =>
  axios.post(`${API}/admin/products`, data, authHeader(token)).then((r) => r.data);
export const adminDeleteProduct = (id, token) =>
  axios.delete(`${API}/admin/products/${id}`, authHeader(token)).then((r) => r.data);
export const adminUploadImage = (fileFormData, token) =>
  axios
    .post(`${API}/admin/upload`, fileFormData, {
      headers: { "X-Admin-Password": token, "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
export const adminUpdateSettings = (data, token) =>
  axios.put(`${API}/admin/settings`, data, authHeader(token)).then((r) => r.data);
export const adminGetOrders = (token) =>
  axios.get(`${API}/admin/orders`, authHeader(token)).then((r) => r.data);
